import {tva} from "@gluestack-ui/nativewind-utils/tva";
import type {VariantProps} from "@gluestack-ui/nativewind-utils/types";
import type {ReactNode} from "react";
import type React from "react";

import {VStack} from "../ui/vstack";

type Props = {
    children: ReactNode;
    space?: "lg";
    useDefaultDivider?: boolean;
} & VariantProps<typeof style>;

const style = tva({
    base: "min-h-[auto] px-5 py-4",
    variants: {
        noBorder: {
            true: "border-0",
            false: "md:px-6 border-b-4 md:border-b border-solid border-blueGray-100"
        },
        useDefaultDivider: {
            false: "px-0 border-b-0"
        }
    }
});

const ModalBlock: React.FC<Props> = ({children, space, useDefaultDivider, noBorder}) => {
    // invalid chilren is ignored
    if (typeof children === "string") {
        return null;
    }

    return (
        <VStack
            className={style({
                noBorder,
                useDefaultDivider
            })}
            space={space}
        >
            {children}
        </VStack>
    );
};

export default ModalBlock;
